class Person {
    constructor(element) {
        if (!(element instanceof HTMLElement)) {
            throw new TypeError("Invalid element");
        }

        this.element = element;
        this.modalId = this.element.dataset.micromodalTrigger ?? null;
        this.modal = document.querySelector(`#${this.modalId}`);

        if (this.modalId !== null && this.modal !== null) {
            this.modalContent = this.modal.querySelector(".person-details");
            this.modalImg = this.modal.querySelector(".person-details-modal__image img");

            this.initEvents();
        }
    }

    initEvents() {
        this.element.addEventListener("click", this.openModal.bind(this));
    }

    openModal(event){
        event.preventDefault();
        const JSONString = event.currentTarget.dataset.object ?? "null";
        const JSONObject = JSON.parse(JSONString);

        console.log({JSONObject});

        const pillList = (JSONObject.category ?? []).map((cat) => {
            if(typeof cat.related_page_url !== "undefined"){
                return `
                    <li><a href="${cat.related_page_url}" class="pill">${cat.name}</a></li>
                `;
            }

            return `
                <li><span class="pill">${cat.name}</span></li>
            `;
        });
        const email = (typeof JSONObject.email !== "undefined") ? `<li><a href="mailto:${JSONObject.email}" target="_blank">${JSONObject.email}</a></li>` : "";
        const phoneNumber = (typeof JSONObject.phone_number !== "undefined") ? ` <li><a href="tel:${JSONObject.phone_number}" target="_blank">${JSONObject.phone_number}</a></li>` : "";

        let socialItems = (Object.keys(JSONObject.socials) ?? []).map((key) => {
            if(typeof JSONObject.socials[key] === "undefined")
                return false;

            return `
                <li>
                    <a href="${JSONObject.socials[key]}" target="_blank" class="social-item">
                        <svg><use xlink:href="#icon--${key}" /></svg>
                        <span>${key}</span>
                    </a>
                </li>
            `;
        });
        socialItems = socialItems.filter(Boolean).join("");
        socialItems = socialItems.length > 0 ? `<ul class="person-details__socials">${socialItems}</ul>` : "";

        this.modalContent.innerHTML = `
            <span class="person-details__job">${JSONObject.job_title ?? ""}</span>
            <h3 class="person-details__name">${JSONObject.title ?? ""}</h3>
            <ul class="person-details__cats pill-list">${pillList ?? ""}</ul>
            ${socialItems}
            <ul class="person-details__contact">
                ${email ?? ""}
                ${phoneNumber ?? ""}
            </ul>
            <div class="person-details__bio">
                ${JSONObject.content ?? ""}
            </div>
        `;

        if(typeof JSONObject.imageURL !== null){
            this.modalImg.src = JSONObject.imageURL;
        }
    }
}

export default Person;
